import {useProfiles} from '@/api/User/useProfiles';
import {locations} from '@/pages/TocaProgramsLanding/utils';
import {useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';

export const useIsV3SessionViewEnabled = () => {
  const [searchParams] = useSearchParams();
  const {currentProfile} = useProfiles();

  return useMemo(() => {
    const siteIdInUrl = searchParams.get('mboSiteId');
    const isTrainer = currentProfile?.role?.includes('trainer');
    const siteId = isTrainer ? siteIdInUrl : currentProfile?.mboDetails?.siteId;

    if (!siteId) {
      return false;
    }

    const site = locations.find((location) => location.siteId === siteId);
    return site?.useV3SessionsView ?? false;
  }, [searchParams, currentProfile]);
};
